import { API_PRESCRIPTION, API_APPOINTMENT, API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function createPrescription(data) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_CREATE_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_CREATE_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_CREATE_FAILED,
    ],
    promise: client => client.post('/prescriptions', data),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function getPrescription(id) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_GET_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_GET_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_GET_FAILED,
    ],
    promise: client => client.get(`/prescriptions/${id}`),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function getPrescriptionOrder(id) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_ORDER_GET_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_ORDER_GET_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_ORDER_GET_FAILED,
    ],
    promise: client => client.get(`/prescription-orders/${id}`),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function getDoctorInfo(doctorId) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_DOCTOR_GET_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_DOCTOR_GET_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_DOCTOR_GET_FAILED,
    ],
    promise: client => client.get(`/v1.3/doctors/${doctorId}`),
    options: {
      clientName: API_APPOINTMENT,
    },
  };
}

export function getListPrescriptionOrders(params, isLoadMore = false) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_LIST_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_LIST_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_LIST_FAILED,
    ],
    promise: client => client.get(`/doctors/prescription-orders`, { params }),
    options: {
      clientName: API_PRESCRIPTION,
    },
    meta: {
      isLoadMore,
    },
  };
}

export function getTemplates() {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_TEMPLATES_GET_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_TEMPLATES_GET_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_TEMPLATES_GET_FAILED,
    ],
    promise: client => client.get('/medicine-instructions'),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function createTemplate(template) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_TEMPLATE_CREATE_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_TEMPLATE_CREATE_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_TEMPLATE_CREATE_FAILED,
    ],
    promise: client => client.post('/medicine-instructions', { template }),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function updateTemplate(instructionId, template) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_TEMPLATE_UPDATE_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_TEMPLATE_UPDATE_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_TEMPLATE_UPDATE_FAILED,
    ],
    promise: client => client.put(`/medicine-instructions/${instructionId}`, { template }),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function deleteTemplate(instructionId) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_TEMPLATE_DELETE_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_TEMPLATE_DELETE_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_TEMPLATE_DELETE_FAILED,
    ],
    promise: client => client.delete(`/medicine-instructions/${instructionId}`),
    options: {
      clientName: API_PRESCRIPTION,
    },
    meta: {
      id: instructionId,
    },
  };
}

export function getPrescriptionConfig() {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_CONFIG_GET_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_CONFIG_GET_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_CONFIG_GET_FAILED,
    ],
    promise: client => client.get('/medicines/config'),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function parsePrescriptionConfig(data) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_CONFIG_PARSE_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_CONFIG_PARSE_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_CONFIG_PARSE_FAILED,
    ],
    promise: client => client.post('/medicines/parse', data),
    options: {
      clientName: API_CONSULT,
      isDecamelizeKeys: false,
    },
  };
}

export function voidPrescription(id) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_VOID_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_VOID_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_VOID_FAILED,
    ],
    promise: client => client.post(`/doctors/prescriptions/${id}/void`),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function getPendingPrescription(consultId) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_GET_PENDING_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_GET_PENDING_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_GET_PENDING_FAILED,
    ],
    promise: client => client.get(`/consults/${consultId}/pending-prescriptions`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

const PRICE_LIST_TYPE_TELECONSULT_SERVICE = 'teleconsult_service';

export function withTeleconsultPriceList(params = {}, serviceId) {
  if (!serviceId) {
    return params;
  }

  return {
    ...params,
    priceListType: PRICE_LIST_TYPE_TELECONSULT_SERVICE,
    priceListTargetId: serviceId,
  };
}

export function searchOtterSgProducts(params) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_SEARCH_PRODUCT_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_SEARCH_PRODUCT_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_SEARCH_PRODUCT_FAILED,
    ],
    promise: client => client.get(`/products`, { params }),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function searchLifepackProducts(params) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_FAILED,
    ],
    promise: client => client.get(`/lifepack-products`, { params }),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function getOtterClinicalTerm(params) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_GET_CLINICAL_TERM_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_GET_CLINICAL_TERM_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_GET_CLINICAL_TERM_FAILED,
    ],
    promise: client => client.get(`/clinical-terms`, { params }),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function getOtterMedicine(id, params) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_GET_OTTER_MEDICINE_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_GET_OTTER_MEDICINE_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_GET_OTTER_MEDICINE_FAILED,
    ],
    promise: client => client.get(`/products/${id}`, { params }),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function getLifepackMedicine(id) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_GET_LIFEPACK_MEDICINE_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_GET_LIFEPACK_MEDICINE_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_GET_LIFEPACK_MEDICINE_FAILED,
    ],
    promise: client => client.get(`/lifepack-products/${id}`),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function getDocumentTemplates(params = {}) {
  return {
    types: [
      ACTION_TYPES.PRESCRIPTION_GET_DOCUMENT_TEMPLATES_REQUESTED,
      ACTION_TYPES.PRESCRIPTION_GET_DOCUMENT_TEMPLATES_SUCCEED,
      ACTION_TYPES.PRESCRIPTION_GET_DOCUMENT_TEMPLATES_FAILED,
    ],
    promise: client =>
      client.get('/templates', {
        params,
      }),
    options: {
      clientName: API_PRESCRIPTION,
    },
  };
}

export function prescriptionResetState() {
  return {
    type: ACTION_TYPES.PRESCRIPTION_RESET,
  };
}
